import { useEffect, useState } from "react";
import { Table, Button } from "antd";
import { UserAddOutlined } from "@ant-design/icons";
import ModifyWarehouseDrawer from "../component/ModifyWarehouseDrawer.jsx";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BASE_API } from "../Config/Config";
import MoreDrawer from "../component/MoreDrawer.jsx";
import { authenticatedFetch } from "../api/fetchprivateapi.js";

const AdminPage = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [moreOpen, setMoreOpen] = useState(false);
    const [warehouseDetails, setWarehouseDetails] = useState([]);
    const [dropdown, setDropdown] = useState([]);

    const navigate = useNavigate();

    const userDetails = JSON.parse(sessionStorage.getItem("userdetails"));

    // const fetchWarehouselist = async () => {
    //     try {
    //         const formData = new FormData();
    //         formData.append("id", userDetails?.id);

    //         const response = await fetch(
    //             `${BASE_API}/apis/GetWarehouse.php`,
    //             {
    //                 method: "POST",
    //                 credentials: "include",
    //                 body: formData,
    //             }
    //         );

    //         const result = await response.json();

    //         if (
    //             result.status === "success" &&
    //             Array.isArray(result.data)
    //         ) {
    //             const formatted = result.data.map((item, index) => ({
    //                 key: index + 1,
    //                 region: item.region,
    //                 location: item.wh_name,
    //                 total_capacity:
    //                     item.capacity_summary?.[0]?.total_capacity || 0,
    //                 occupancy:
    //                     item.capacity_summary?.[0]?.occupancy || 0,
    //                 available:
    //                     item.capacity_summary?.[0]?.available || 0,
    //                 occupancy_percentage:
    //                     item.capacity_summary?.[0]
    //                         ?.occupancy_percentage || 0,
    //                 available_percentage:
    //                     item.capacity_summary?.[0]
    //                         ?.available_percentage || 0,
    //             }));

    //             const totalRow = {
    //                 key: "",
    //                 location: t('total'),
    //                 total_capacity: result.total.total_capacity,
    //                 occupancy: result.total.total_occupancy,
    //                 available: result.total.total_available,
    //                 occupancy_percentage: result.total.total_occupancy_percentage,
    //                 available_percentage: result.total.total_available_percentage,
    //                 isTotal: true
    //             };

    //             const finalData = [...formatted, totalRow]


    //             setWarehouseDetails(finalData);
    //         } else {
    //             setWarehouseDetails([]); // always array
    //         }
    //     } catch (err) {
    //         console.error("Fetch Error:", err);
    //         setWarehouseDetails([]); // prevent crash
    //     }
    // };

    // const fetchRegion = async () => {
    //     try {
    //         const formData = new FormData();
    //         formData.append("user_id", userDetails?.id);

    //         const response = await fetch(
    //             `${BASE_API}/apis/getRegion.php`,
    //             {
    //                 method: "POST",
    //                 body: formData,
    //                 credentials: "include"

    //             }
    //         );

    //         const result = await response.json();

    //         if (result.status === "success") {
    //             setDropdown(result?.data);
    //         } else {
    //             setDropdown([]);
    //         }
    //     } catch (err) {
    //         console.error("Fetch Error:", err);
    //         setDropdown([]);
    //     }
    // };


    const fetchWarehouselist = async () => {
        try {
            const formData = new FormData();
            formData.append("id", userDetails?.id ?? "");

            const response = await authenticatedFetch(
                `${BASE_API}/apis/GetWarehouse.php`,
                {
                    method: "POST",
                    body: formData
                }
            );

            // Stop if session is expired or invalid
            if (!response) return;

            const result = await response.json();

            if (
                response.ok &&
                result.status === "success" &&
                Array.isArray(result.data)
            ) {
                const formatted = result.data.map((item, index) => ({
                    key: index + 1,
                    region: item.region,
                    location: item.wh_name,
                    total_capacity:
                        item.capacity_summary?.[0]?.total_capacity || 0,
                    occupancy:
                        item.capacity_summary?.[0]?.occupancy || 0,
                    available:
                        item.capacity_summary?.[0]?.available || 0,
                    occupancy_percentage:
                        item.capacity_summary?.[0]?.occupancy_percentage || 0,
                    available_percentage:
                        item.capacity_summary?.[0]?.available_percentage || 0,
                }));

                const totalRow = {
                    key: "",
                    location: t("total"),
                    total_capacity: result.total?.total_capacity || 0,
                    occupancy: result.total?.total_occupancy || 0,
                    available: result.total?.total_available || 0,
                    occupancy_percentage:
                        result.total?.total_occupancy_percentage || 0,
                    available_percentage:
                        result.total?.total_available_percentage || 0,
                    isTotal: true
                };

                const finalData = [...formatted, totalRow];

                setWarehouseDetails(finalData);

            } else {
                setWarehouseDetails([]);
            }

        } catch (err) {
            console.error("Fetch Warehouse List Error:", err);
            setWarehouseDetails([]);
        }
    };

    const fetchRegion = async () => {
        try {
            const formData = new FormData();
            formData.append("user_id", userDetails?.id ?? "");

            const response = await authenticatedFetch(
                `${BASE_API}/apis/getRegion.php`,
                {
                    method: "POST",
                    body: formData
                }
            );

            // Stop if session is expired or invalid
            if (!response) return;

            const result = await response.json();

            if (
                response.ok &&
                result.status === "success" &&
                Array.isArray(result.data)
            ) {
                setDropdown(result.data);
            } else {
                setDropdown([]);
            }

        } catch (err) {
            console.error("Fetch Region Error:", err);
            setDropdown([]);
        }
    };

    useEffect(() => {
        fetchWarehouselist();
        fetchRegion();
    }, []);

    const columns = [
        {
            title: t('sNo'),
            dataIndex: "key",
        },
        {
            title: t('region'),
            dataIndex: "region",
        },
        {
            title: t('location'),
            dataIndex: "location",
        },
        {
            title: t('totalCapacity'),
            dataIndex: "total_capacity",
        },
        {
            title: t('occupancy'),
            dataIndex: "occupancy",
        },
        {
            title: t('available'),
            dataIndex: "available",
        },
        {
            title: t('occupancyPercent'),
            render: (_, record) =>
                `${record.occupancy_percentage}%`,
        },
        {
            title: t('availablePercent'),
            render: (_, record) =>
                `${record.available_percentage}%`,
        },
    ];

    return (
        <div className="container min-vh-100 py-4">
            {/* Top Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="fw-bold text-primary">{t('warehouseAdminPanel')}</h3>

                <div className="d-flex gap-2">

                    <Button
                        type="primary"
                        onClick={() => setOpen(true)}
                    >
                        <i class="bi bi-houses"></i>
                        {t('warehouse')}
                    </Button>

                    <ModifyWarehouseDrawer
                        open={open}
                        onClose={() => setOpen(false)}
                        dropdown={dropdown}
                        fetchWarehouselist={fetchWarehouselist}
                        fetchRegion={fetchRegion}
                    />

                    <Button
                        type="primary"
                        className="bg-success"
                        onClick={() =>
                            navigate("/warehouse-Admin/report", {
                                state: {
                                    dropdownData: dropdown
                                }
                            })
                        }
                    >
                        <i className="bi bi-bar-chart"></i> {t('report')}
                    </Button>

                    <Button icon={<UserAddOutlined />} type="default" onClick={() => setMoreOpen(true)}>
                        {t('More')}
                    </Button>

                    <MoreDrawer
                        open={moreOpen}
                        onClose={() => setMoreOpen(false)}
                    />
                </div>
            </div>

            {/* Table Card */}
            <div className="card shadow-sm border-0">
                <div className="card-body">
                    <style>
                        {`
                            .custom-ant-table .ant-table-thead > tr > th {
                            background-color: #536aa0;
                            color: white;
                            font-weight: 600;
                            text-align: center;
                            }

                            .custom-ant-table .ant-table {
                            border-radius: 10px;
                            overflow: hidden;
                            }

                            .custom-ant-table .ant-table-tbody > tr:hover > td {
                            background: #f5f7ff;
                            }

                            /* 🔴 Over capacity row */
                            .row-danger td {
                            background-color: #ffe3e5 !important;
                            }
                        `}
                    </style>

                    <Table
                        className="custom-ant-table"
                        columns={columns}
                        dataSource={warehouseDetails || []}
                        rowClassName={(record) =>
                            record.occupancy > record.total_capacity ? "row-danger" : ""
                        }
                        bordered
                        scroll={{ x: "max-content" }}
                        pagination={{
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "20", "50"],
                            position: ["bottomRight"]
                        }}
                        onRow={(record) => ({
                            style: record.isTotal
                                ? {
                                    fontWeight: "bold",
                                    backgroundColor: "#f5f5f5",
                                }
                                : {},
                        })}
                    />
                </div>
            </div>
        </div >
    );
};

export default AdminPage;